export class Expression {
  static getOperation (type) {
    let filterType = ''
    switch (type) {
      case 'EqualsTo':
        filterType = '='
        break
      case 'NotEqualsTo':
        filterType = '!='
        break
      case 'GreaterThan':
        filterType = '>'
        break
      case 'GreaterThanEquals':
        filterType = '>='
        break
      case 'MinorThan':
        filterType = '<'
        break
      case 'MinorThanEquals':
        filterType = '<='
        break
      case 'LikeExpression':
        filterType = 'includes'
        break
      case 'IsNull':
        filterType = '空'
        break
      case 'IsNotNull':
        filterType = '非空'
        break
      default:
        break
    }
    return filterType
  }
}



// WEBPACK FOOTER //
// ./src/shared/expressdion.js